<lg-fade-in>
  <lg-container>
    <lg-title>{{ 'main.title' | translate }}</lg-title>

    @if (!isOnboardingComplete()) {
      <lg-card>
        <lg-onboarding></lg-onboarding>
      </lg-card>
    }

    @defer {
      <lg-flex-row [mobileMode]="true"
                   [top]="true"
                   [wrap]="true"
                   cols="2">
        @if (recipes.length|async) {
          <lg-card>
            <lg-last-edited-recipes></lg-last-edited-recipes>
          </lg-card>
        }

        @if (products.length|async) {
          <lg-card>
            <lg-last-edited-products></lg-last-edited-products>
          </lg-card>
        }
      </lg-flex-row>
    } @error {
      {{'main.defer-load-error' | translate }}
    }
  </lg-container>
</lg-fade-in>
